import React, { useEffect, useState, useRef } from 'react'
import Container from '../../Container/Container'
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';

function Comment({ onSubmit, onBack, ticket, initialValues, isSubmitting }) {
    const location = useLocation()
    const [orderFor, setOrderFor] = useState(initialValues.order_for)
    const profile = useSelector((state) => state.profile.profile);
    const [hasUserSelected, setHasUserSelected] = useState(false);
    const [initialNotesValue, setInitialNotesValue] = useState('');
    const [remainingCharacters, setRemainingCharacters] = useState(null);
    const [notesError, setNotesError] = useState('');
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [hasInitialized, setHasInitialized] = useState(false); // Add this flag
    const textareaRef = useRef(null);
    // const [mappedDefaultColor, setMappedDefaultColor] = useState("Brown");
    const { register, handleSubmit, formState: { errors }, getValues, setValue, watch } = useForm({
        defaultValues: initialValues
    });

    const mappedDefaultColor = useSelector((state) => state.profile.mappedDefaultColor);

    const currentNotesValue = watch("Notes");
    // Update SubmittedBy field when profile data is available
    useEffect(() => {
        if (!getValues("SubmittedBy")) {
            setValue("SubmittedBy", `${profile?.firstName || ""} ${profile?.lastName || ""}`);
        }
    }, [profile, setValue, getValues]);

    const handleBack = () => {
        // Save current form values before going back
        const currentValues = getValues();
        onBack(currentValues);
    };
    useEffect(() => {
        setValue("For_status", false);
    }, [])

    // useEffect(() => {
    //     if (!initialValues) return;
    //     console.log(initialValues, "initialValues");

    //     const pantsPresent = !!initialValues?.belt;
    //     const pantSupportsBelt = initialValues?.belt?.supportsBelt !== false;
    //     const shoeColor = initialValues?.shoe_color;
    //     const tieSelected = !!initialValues?.Tie;
    //     const orderFor = initialValues?.order_for; // "Men" or "Boys"

    //     if (tieSelected && !pantsPresent && !shoeColor) {
    //         const prefix = orderFor === "Men" ? "Mens" : orderFor;
    //         const processedNotes = `${prefix}`;
    //         setInitialNotesValue(processedNotes);
    //         setValue("Notes", processedNotes);
    //         console.log(processedNotes, "→ Final Notes");
    //         return; // Skip the rest
    //     }

    //     if (pantsPresent && !pantSupportsBelt) {
    //         setValue("belt", ""); // Clear the previous belt value
    //     }

    //     const userBeltColor = getValues("belt");
    //     const defaultBeltColor = mappedDefaultColor || shoeColor;
    //     const beltWasChanged = !!userBeltColor && userBeltColor !== defaultBeltColor;

    //     let notes = "";

    //     // ✅ Case A: NO Pant, but shoe is selected → Shoe Color
    //     // if (!pantsPresent && shoeColor) {
    //     //     notes = `${shoeColor} Shoe`;
    //     // }

    //     // ✅ Case B: Pant selected but does NOT support belt → only show shoe color
    //     if (pantsPresent && !pantSupportsBelt && shoeColor) {
    //         notes = `${shoeColor} Belt`;
    //     }

    //     // ✅ Case C: Pant selected + supports belt + user selected belt → Belt
    //     else if (pantsPresent && pantSupportsBelt && beltWasChanged) {
    //         notes = `${userBeltColor} Belt`;
    //     }

    //     // ✅ Case D: Pant selected + supports belt + belt NOT selected + shoe selected → Shoe Color
    //     else if (pantsPresent && pantSupportsBelt && !beltWasChanged && shoeColor) {
    //         notes = `${shoeColor} Belt`;
    //     }

    //     // ✅ ✅ NEW CONDITION 1:
    //     // Pant ✅, Supports Belt ✅, Belt ❌, Shoe ❌ → show default belt color
    //     else if (pantsPresent && pantSupportsBelt && !beltWasChanged && !shoeColor) {
    //         notes = `${defaultBeltColor} Belt`;
    //     }

    //     // ✅ ✅ NEW CONDITION 2:
    //     // Pant ✅, Supports Belt ❌, Belt ❌, Shoe ✅ → show shoe color
    //     else if (pantsPresent && !pantSupportsBelt && !userBeltColor && shoeColor) {
    //         notes = `${shoeColor} Shoe`;
    //     }

    //     // ✅ Add Tie (Mens/Boys) prefix without modifying above logic
    //     if (tieSelected && !notes) {
    //         const prefix = orderFor === "Men" ? "Mens" : orderFor;
    //         notes = `${prefix}, ${notes}`;
    //     }

    //     const processedNotes = notes.replace(/,/g, ' ');
    //     setInitialNotesValue(processedNotes);

    //     setValue("Notes", processedNotes);
    //     console.log(processedNotes, "→ Final Notes");
    // }, [initialValues, setValue, getValues]);
    useEffect(() => {
        if (!initialValues || hasInitialized) return;
        console.log(initialValues, "initialValues");
        console.log("Belt object:", initialValues?.belt);
        console.log("Drop Shipping Switch:", initialValues?.dropShippingswitch);

        // Check if we're in update mode (if comments already exist)
        const existingComments = initialValues.comments || initialValues.Notes;
        const isUpdate = location.pathname !== "/add-order" && existingComments;
        setIsUpdateMode(isUpdate);

        const pantsPresent = !!initialValues?.belt;
        const pantSupportsBelt = initialValues?.belt?.supportsBelt !== false;
        const shoeColor = initialValues?.shoe_color;
        const tieSelected = !!initialValues?.Tie;
        const orderFor = initialValues?.order_for; // "Men" or "Boys"
        const isDropShipping = initialValues?.dropShippingswitch === true;


        // If only Tie is selected and nothing else
        const noOtherSelections = !initialValues?.Pant &&
            !initialValues?.Coat &&
            !initialValues?.Shirt &&
            !initialValues?.Vest &&
            !initialValues?.shoe_color &&
            !initialValues?.belt;

        // Generate the auto-generated notes part
        let autoGeneratedNotes = "";
        if (isDropShipping) {
            autoGeneratedNotes = "Drop Ship";
        }
        // if (tieSelected && pantsPresent) {
        //     autoGeneratedNotes = "";
        // }
        if (tieSelected && noOtherSelections) {
            const prefix = orderFor === "Men" ? "Mens" : orderFor;
            autoGeneratedNotes = autoGeneratedNotes
                ? `${autoGeneratedNotes} ${prefix}`
                : `${prefix}`;
        } else {
            if (pantsPresent && !pantSupportsBelt) {
                setValue("belt", ""); // Clear the previous belt value
            }

            const userBeltColor = getValues("belt");
            const defaultBeltColor = mappedDefaultColor || shoeColor;
            const beltWasChanged = !!userBeltColor && userBeltColor !== defaultBeltColor;
            let itemNotes = "";
            // ✅ Case B: Pant selected but does NOT support belt → only show shoe color
            if (pantsPresent && !pantSupportsBelt && shoeColor) {
                itemNotes = `${shoeColor} Belt`;
            }
            // ✅ Case C: Pant selected + supports belt + user selected belt → Belt
            else if (pantsPresent && pantSupportsBelt && beltWasChanged) {
                itemNotes = `${userBeltColor} Belt`;
            }
            // ✅ Case D: Pant selected + supports belt + belt NOT selected + shoe selected → Shoe Color
            else if (pantsPresent && pantSupportsBelt && !beltWasChanged && shoeColor) {
                itemNotes = `${shoeColor} Belt`;
            }
            // ✅ NEW CONDITION 1: Pant ✅, Supports Belt ✅, Belt ❌, Shoe ❌ → show default belt color
            else if (pantsPresent && pantSupportsBelt && !beltWasChanged && !shoeColor && defaultBeltColor) {
                itemNotes = `${defaultBeltColor} Belt`;
            }
            // ✅ NEW CONDITION 2: Pant ✅, Supports Belt ❌, Belt ❌, Shoe ✅ → show shoe color
            else if (pantsPresent && !pantSupportsBelt && !userBeltColor && shoeColor) {
                itemNotes = `${shoeColor} Shoe`;
            }
            // NEW: If dropship is enabled and pant doesn't support belt, only show "Drop Ship"
            else if (isDropShipping && pantsPresent && !pantSupportsBelt) {
                itemNotes = ""; // Don't add belt/shoe info
            }
            if (itemNotes) {
                autoGeneratedNotes = autoGeneratedNotes ? `${autoGeneratedNotes} ${itemNotes}` : itemNotes;
            }
            // ✅ Add Tie (Mens/Boys) prefix without modifying above logic
            // if (tieSelected && autoGeneratedNotes) {
            //     const prefix = orderFor === "Men" ? "Mens" : orderFor;
            //     autoGeneratedNotes = `${prefix}, ${autoGeneratedNotes}`;
            // }
        }

        let processedAutoNotes = autoGeneratedNotes.replace(/,/g, ' ');

        if (isDropShipping && tieSelected) {
            const prefix = orderFor === "Men" ? "Mens" : orderFor;
            // If Drop Ship already present, add prefix before it
            if (!processedAutoNotes.toLowerCase().includes(prefix.toLowerCase())) {
                processedAutoNotes = processedAutoNotes.includes("Drop Ship")
                    ? `${processedAutoNotes} ${prefix}`
                    : `${prefix} ${processedAutoNotes}`;
            }
        }
        // 🧠 Ensure Tie prefix appears even if no Pant / Drop Ship in update mode
        if (
            !isDropShipping &&
            !initialValues?.Pant &&
            !initialValues?.belt &&
            tieSelected
        ) {
            const prefix = orderFor === "Men" ? "Mens" : orderFor;
            const tieOnlyNote = `${prefix}`;
            console.log("No Pant or DropShip, Tie present → showing:", tieOnlyNote);

            setInitialNotesValue(tieOnlyNote);
            setValue("Notes", tieOnlyNote);
            setHasInitialized(true);
            return;
        }

        // 🛑 Guard: no belt, no dropship, and stale notes detected
        if (
            !initialValues?.belt &&
            !initialValues?.shoe_color &&
            !isDropShipping &&
            existingComments &&
            /(Drop Ship|Belt|Shoe)/i.test(existingComments)
        ) {
            console.log("Clearing stale auto notes (no belt/shoe/drop ship in current order)");
            setValue("Notes", "");
            setInitialNotesValue("");
            setHasInitialized(true);
            return;
        }

        if (isUpdate && existingComments) {
            if (isDropShipping && !initialValues?.belt && /Belt/i.test(existingComments)) {
                const cleaned = existingComments.replace(/\b\w*\s?Belt\b/gi, "").trim();
                console.log("Cleaned stale Belt info for Drop Ship order:", cleaned);
                setValue("Notes", cleaned);
                setInitialNotesValue(cleaned);
                setHasInitialized(true);
                return;
            }
            // In update mode, extract user-added content
            setInitialNotesValue(processedAutoNotes);

            // Check if existing comments start with our auto-generated notes
            if (existingComments.startsWith(processedAutoNotes)) {
                const userAddedContent = existingComments.substring(processedAutoNotes.length).trim();
                console.log("User Added Content:", userAddedContent);

                // Reconstruct with new auto-generated notes + preserved user content
                const newFullNotes = userAddedContent
                    ? `${processedAutoNotes} ${userAddedContent}`
                    : processedAutoNotes;
                // Preserve the existing full comments (auto-generated + user-added)
                setValue("Notes", existingComments);
                console.log(existingComments, "→ Preserved existing comments in update mode");
            } else {
                // If existing comments don't match expected pattern, use them as-is
                // but still set the initial value for protection
                // setValue("Notes", existingComments);
                // Try to detect what might be the auto-generated part
                const words = existingComments.split(' ');
                let detectedInitial = '';
                for (let i = 0; i < words.length; i++) {
                    const partial = words.slice(0, i + 1).join(' ');
                    if (processedAutoNotes.includes(partial) || partial.includes('Belt') || partial.includes('Shoe') || partial.includes('Mens') || partial.includes('Drop') || partial.includes('Ship')) {
                        detectedInitial = partial;
                        // detectedInitial = partial.slice(0, i + 1).join(' ').length;
                    } else if (detectedInitial > 0) {
                        break;
                    }
                }
                //     if (detectedInitial) {
                //         setInitialNotesValue(detectedInitial);
                //     } else {
                //         setInitialNotesValue(processedAutoNotes);
                //     }
                //     console.log(existingComments, "→ Used existing comments as-is in update mode");
                // }
                let userAddedContent = '';
                if (detectedInitial > 0) {
                    userAddedContent = existingComments.substring(detectedInitial).trim();
                    console.log("Detected User Content:", userAddedContent);
                }

                // Reconstruct with new auto-generated notes + detected user content
                const newFullNotes = userAddedContent
                    ? `${processedAutoNotes} ${userAddedContent}`
                    : processedAutoNotes;
                if (isDropShipping && tieSelected && !newFullNotes.includes(orderFor)) {
                    const prefix = orderFor === "Men" ? "Mens" : orderFor;
                    processedAutoNotes = processedAutoNotes.includes("Drop Ship")
                        ? `${prefix} ${processedAutoNotes}`
                        : `${processedAutoNotes} ${prefix}`;
                }
                setValue("Notes", newFullNotes);
                console.log("Updated Notes (detected user content):", newFullNotes);
            }
        } else {
            // In add mode, set the auto-generated notes
            setInitialNotesValue(processedAutoNotes);
            setValue("Notes", processedAutoNotes);
            console.log(processedAutoNotes, "→ Set auto-generated notes in add mode");
        }

        setHasInitialized(true);
    }, [initialValues]);



    // const handleNotesChange = (e) => {
    //     const inputValue = e.target.value;
    //     const initialLength = initialNotesValue.length;

    //     // If user tries to modify the initial part, restore it
    //     if (!inputValue.startsWith(initialNotesValue)) {
    //         // Restore the initial value and preserve any additional content
    //         const userAddedContent = inputValue.substring(initialLength).replace(/[^a-zA-Z0-9 ]/g, '');

    //         if (userAddedContent.length > 25) {
    //             setNotesError('Maximum 25 characters allowed');
    //             return;
    //         } else {
    //             setNotesError('');
    //         }

    //         const restoredValue = initialNotesValue + userAddedContent;
    //         setValue("Notes", restoredValue);


    //         // Set cursor position after the initial value
    //         setTimeout(() => {
    //             if (textareaRef.current) {
    //                 textareaRef.current.setSelectionRange(initialLength, initialLength);
    //             }
    //         }, 0);
    //         return;
    //     }

    //     // Convert any commas in the user-added portion to spaces
    //     const userAddedPortion = inputValue.substring(initialLength).replace(/[^a-zA-Z0-9 ]/g, '');

    //     const nonSpaceCount = userAddedPortion.replace(/\s/g, '').length;

    //     if (nonSpaceCount > 25) {
    //         setNotesError('Maximum 25 characters allowed (spaces not counted)');

    //         // Truncate to 25 non-space characters while preserving spaces
    //         let truncatedContent = '';
    //         let charCount = 0;

    //         for (let i = 0; i < userAddedPortion.length && charCount < 25; i++) {
    //             const char = userAddedPortion[i];
    //             if (char === ' ') {
    //                 truncatedContent += char; // Add space without counting
    //             } else {
    //                 truncatedContent += char;
    //                 charCount++; // Count non-space character
    //             }
    //         }

    //         const finalValue = initialNotesValue + truncatedContent;
    //         setValue("Notes", finalValue);

    //         // Set cursor to end of allowed content
    //         setTimeout(() => {
    //             if (textareaRef.current) {
    //                 textareaRef.current.setSelectionRange(finalValue.length, finalValue.length);
    //             }
    //         }, 0);
    //         return;
    //     } else {
    //         setNotesError('');
    //     }
    //     const finalValue = initialNotesValue + userAddedPortion;


    //     setValue("Notes", finalValue);

    //     if (finalValue.length === initialNotesValue.length) {
    //         setRemainingCharacters(25 - finalValue.length);
    //     } else {
    //         setRemainingCharacters(null);
    //     }
    // };

    // // Handle keydown to prevent certain actions on the protected portion
    // const handleNotesKeyDown = (e) => {
    //     const textarea = e.target;
    //     const cursorPosition = textarea.selectionStart;
    //     const initialLength = initialNotesValue.length;
    //     const currentLength = textarea.value.length;
    //     // const userAddedLength = currentLength - initialLength;
    //     const userAddedContent = textarea.value.substring(initialLength);
    //     const nonSpaceCount = userAddedContent.replace(/\s/g, '').length;


    //     // Prevent deletion/modification of initial value
    //     if (cursorPosition < initialLength) {
    //         // Allow navigation keys
    //         const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];

    //         if (!allowedKeys.includes(e.key)) {
    //             e.preventDefault();
    //             // Move cursor to the end of initial value
    //             setTimeout(() => {
    //                 textarea.setSelectionRange(initialLength, initialLength);
    //             }, 0);
    //         }
    //     }

    //     if (
    //         nonSpaceCount >= 25 &&
    //         textarea.selectionStart === textarea.selectionEnd && // only block if not selecting to replace
    //         e.key !== ' ' // only block if not selecting to replace
    //     ) {
    //         const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];
    //         if (!allowedKeys.includes(e.key)) {
    //             e.preventDefault();
    //             setNotesError('Maximum 25 characters allowed');

    //         }
    //     }
    //     const allowedKeyRegex = /^[a-zA-Z0-9 ]$/;
    //     if (
    //         e.key.length === 1 && // filter out keys like "Shift", "ArrowRight"
    //         !allowedKeyRegex.test(e.key)
    //     ) {
    //         e.preventDefault();
    //     }
    // };

    // const handleNotesPaste = (e) => {
    //     e.preventDefault();
    //     const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    //     const processedText = pastedText.replace(/[^a-zA-Z0-9 ]/g, '');

    //     const textarea = e.target;
    //     const cursorPosition = textarea.selectionStart;
    //     const currentValue = textarea.value;

    //     // Only allow pasting after the initial value
    //     if (cursorPosition < initialNotesValue.length) {
    //         return;
    //     }

    //     const currentUserAddedContent = currentValue.substring(initialNotesValue.length);
    //     const currentNonSpaceCount = currentUserAddedContent.replace(/\s/g, '').length;
    //     const pastedNonSpaceCount = processedText.replace(/\s/g, '').length;

    //     const availableSpace = 25 - currentNonSpaceCount;

    //     // Truncate pasted text if it exceeds available non-space character limit
    //     let truncatedText = '';
    //     let charCount = 0;

    //     for (let i = 0; i < processedText.length && charCount < availableSpace; i++) {
    //         const char = processedText[i];
    //         if (char === ' ') {
    //             truncatedText += char; // Add space without counting
    //         } else {
    //             truncatedText += char;
    //             charCount++; // Count non-space character
    //         }
    //     }

    //     if (pastedNonSpaceCount > availableSpace) {
    //         setNotesError('Maximum 25 characters allowed (spaces not counted)');
    //     } else {
    //         setNotesError('');
    //     }

    //     const newValue = currentValue.substring(0, cursorPosition) + truncatedText + currentValue.substring(textarea.selectionEnd);
    //     setValue("Notes", newValue);

    //     const newUserAddedContent = newValue.substring(initialNotesValue.length);
    //     const newNonSpaceCount = newUserAddedContent.replace(/\s/g, '').length;
    //     setRemainingCharacters(25 - newNonSpaceCount);

    //     // Set cursor position after pasted text
    //     setTimeout(() => {
    //         const newCursorPosition = cursorPosition + truncatedText.length;
    //         textarea.setSelectionRange(newCursorPosition, newCursorPosition);
    //     }, 0);
    // };

    // Handle click to ensure cursor doesn't go before initial value

    const handleNotesChange = (e) => {
        const inputValue = e.target.value;
        const initialLength = initialNotesValue.length;

        // If user tries to modify the initial part, restore it
        if (!inputValue.startsWith(initialNotesValue)) {
            // Restore the initial value and preserve any additional content
            const userAddedContent = inputValue.substring(initialLength).replace(/[^a-zA-Z0-9 ]/g, '');

            // Check total length including spaces
            const totalLength = initialNotesValue.length + userAddedContent.length;
            if (totalLength > 25) {
                setNotesError('Maximum 25 characters allowed (including spaces)');
                const allowedUserLength = 25 - initialNotesValue.length;
                const truncatedUserContent = userAddedContent.substring(0, allowedUserLength);
                const restoredValue = initialNotesValue + truncatedUserContent;
                setValue("Notes", restoredValue, { shouldDirty: true, shouldTouch: true });
            } else {
                setNotesError('');
                const restoredValue = initialNotesValue + userAddedContent;
                setValue("Notes", restoredValue, { shouldDirty: true, shouldTouch: true });
            }

            // Set cursor position after the initial value
            setTimeout(() => {
                if (textareaRef.current) {
                    textareaRef.current.setSelectionRange(initialLength, initialLength);
                }
            }, 0);
            return;
        }

        // Convert any commas in the user-added portion to spaces
        const userAddedPortion = inputValue.substring(initialLength).replace(/[^a-zA-Z0-9 ]/g, '');

        // Check total length including spaces
        const totalLength = initialNotesValue.length + userAddedPortion.length;

        if (totalLength > 25) {
            setNotesError('Maximum 25 characters allowed (including spaces)');
            // Calculate how many characters user can add
            const allowedUserLength = 25 - initialNotesValue.length;
            const truncatedUserContent = userAddedPortion.substring(0, allowedUserLength);
            const finalValue = initialNotesValue + truncatedUserContent;
            setValue("Notes", finalValue, { shouldDirty: true, shouldTouch: true });

            // Set cursor to end of allowed content
            setTimeout(() => {
                if (textareaRef.current) {
                    textareaRef.current.setSelectionRange(finalValue.length, finalValue.length);
                }
            }, 0);
            return;
        } else {
            setNotesError('');
        }

        const finalValue = initialNotesValue + userAddedPortion;
        setValue("Notes", finalValue, { shouldDirty: true, shouldTouch: true });

        // Update remaining characters display
        const remaining = 25 - finalValue.length;
        if (remaining >= 0) {
            setRemainingCharacters(remaining);
        }
    };

    // Handle keydown to prevent certain actions on the protected portion
    const handleNotesKeyDown = (e) => {
        const textarea = e.target;
        const cursorPosition = textarea.selectionStart;
        const initialLength = initialNotesValue.length;
        const currentLength = textarea.value.length;

        // Prevent deletion/modification of initial value
        if (cursorPosition < initialLength) {
            // Allow navigation keys
            const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];

            if (!allowedKeys.includes(e.key)) {
                e.preventDefault();
                // Move cursor to the end of initial value
                setTimeout(() => {
                    textarea.setSelectionRange(initialLength, initialLength);
                }, 0);
            }
        }

        // Check if we've reached the 25 character limit (including spaces)
        if (
            currentLength >= 25 &&
            textarea.selectionStart === textarea.selectionEnd && // only block if not selecting to replace
            e.key !== 'Backspace' && e.key !== 'Delete' // allow deletion
        ) {
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];
            if (!allowedKeys.includes(e.key)) {
                e.preventDefault();
                setNotesError('Maximum 25 characters allowed (including spaces)');
            }
        }

        // Only allow alphanumeric characters and spaces
        const allowedKeyRegex = /^[a-zA-Z0-9 ]$/;
        if (
            e.key.length === 1 && // filter out keys like "Shift", "ArrowRight"
            !allowedKeyRegex.test(e.key)
        ) {
            e.preventDefault();
        }
    };

    // Handle paste events
    const handleNotesPaste = (e) => {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const processedText = pastedText.replace(/[^a-zA-Z0-9 ]/g, '');

        const textarea = e.target;
        const cursorPosition = textarea.selectionStart;
        const currentValue = textarea.value;

        // Only allow pasting after the initial value
        if (cursorPosition < initialNotesValue.length) {
            return;
        }

        const currentLength = currentValue.length;
        const availableSpace = 25 - currentLength;

        // Truncate pasted text if it exceeds available space
        const truncatedText = processedText.substring(0, availableSpace);

        if (processedText.length > availableSpace) {
            setNotesError('Maximum 25 characters allowed (including spaces)');
        } else {
            setNotesError('');
        }

        const newValue = currentValue.substring(0, cursorPosition) + truncatedText + currentValue.substring(textarea.selectionEnd);
        setValue("Notes", newValue);

        const remaining = 25 - newValue.length;
        if (remaining >= 0) {
            setRemainingCharacters(remaining);
        }

        // Set cursor position after pasted text
        setTimeout(() => {
            const newCursorPosition = cursorPosition + truncatedText.length;
            textarea.setSelectionRange(newCursorPosition, newCursorPosition);
        }, 0);
    };
    const handleNotesClick = (e) => {
        const textarea = e.target;
        const cursorPosition = textarea.selectionStart;
        const initialLength = initialNotesValue.length;

        if (cursorPosition < initialLength) {
            setTimeout(() => {
                textarea.setSelectionRange(initialLength, initialLength);
            }, 0);
        }
    };







    return (
        <>
            <Container>
                <div class="nk-content ">
                    <div class="container-fluid">
                        <div class="nk-content-inner">
                            <div class="nk-content-body">
                                <div class="nk-block-head nk-block-head-sm">
                                    <div class="nk-block-between">
                                        <div class="nk-block-head-content">
                                            <h3 class="nk-block-title page-title">{location.pathname == "/add-order" ? "Add" : "Update"} Order {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3></div>

                                    </div>
                                </div>

                                <div class="card card-full">
                                    <div class="card-inner">
                                        <div class="stepperLeft">
                                            <div className="row">
                                                <div className="col-md-4 brIght">
                                                    <section class="section1">
                                                        <header>
                                                            <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-order" ? "Add" : "Update"} Event Item
                                                        </header>
                                                    </section>
                                                    <section class="section2">
                                                        <header>
                                                            <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-order" ? "Add" : "Update"} Measured
                                                        </header>
                                                    </section>
                                                    {/* <section>
                                                            <header>
                                                                <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div> Add Style Detail
                                                            </header>
                                                        </section> */}
                                                    <section>
                                                        <header>
                                                            <div class="bead current"><span>3</span></div> {location.pathname == "/add-order" ? "Add" : "Update"} Comment
                                                        </header>
                                                    </section>
                                                </div>

                                                <div className="col-md-8">
                                                    <h4>{location.pathname == "/add-order" ? "Add" : "Update"} Comment </h4>
                                                    <div className="inputCardBox mt-4">
                                                        <form onSubmit={handleSubmit(onSubmit)}>
                                                            {/* <div className="row">
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Notes  <span className="text-red-500"></span></label>
                                                                    <textarea className="" placeholder='For Your Reference Only'  {...register("Notes")}></textarea>
                                                                    {errors.Notes && <p className='red'>{errors.Notes.message}</p>}

                                                                </div> */}
                                                            <div className="row">
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Notes  <span className="text-red-500"></span></label>
                                                                    <textarea
                                                                        ref={textareaRef}
                                                                        className=""
                                                                        placeholder={initialNotesValue ? 'Add additional notes after the initial content...' : 'For Your Reference Only'}
                                                                        {...register("Notes")}
                                                                        onChange={handleNotesChange}
                                                                        onKeyDown={handleNotesKeyDown}
                                                                        onPaste={handleNotesPaste}
                                                                        onClick={handleNotesClick}
                                                                    // style={{
                                                                    //     background: initialNotesValue ?
                                                                    //         `linear-gradient(to right, #f0f8ff 0%, #f0f8ff ${(initialNotesValue.length / (currentNotesValue?.length || 1)) * 100}%, white ${(initialNotesValue.length / (currentNotesValue?.length || 1)) * 100}%, white 100%)` :
                                                                    //         'white'
                                                                    // }}
                                                                    />
                                                                    {/* {initialNotesValue && (
                                                                        <small className="text-muted">
                                                                            Protected content: "{initialNotesValue}" - You can only add content after this text
                                                                        </small>
                                                                    )} */}
                                                                    {notesError && <p className='red' style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{notesError}</p>}

                                                                    {errors.Notes && <p className='red'>{errors.Notes.message}</p>}
                                                                    {remainingCharacters !== null && !notesError && (
                                                                        <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>You have {remainingCharacters} to 25 characters remaining</p>
                                                                    )}
                                                                </div>
                                                                <div className="col-md-6 mb-3">
                                                                    <label>Submitted By  <span className="text-red-500">*</span></label>
                                                                    <input class="" type="text" placeholder="Enter name"  {...register("SubmittedBy", { required: "Submitted by is required" })} />
                                                                    {errors.SubmittedBy && <p className='red'>{errors.SubmittedBy.message}</p>}
                                                                </div>
                                                                {/* <div className="col-md-6 mb-3">
                                                                    <label>Customer Next Slip  <span className="text-red-500">*</span></label>
                                                                    <input class="" type="text" placeholder="Enter name"   {...register("NextSlip", { required: "Next slip is required" })} />
                                                                    {errors.NextSlip && <p className='red'>{errors.NextSlip.message}</p>}

                                                                </div> */}

                                                                <div class="col-md-12 mt-3">
                                                                    <a className="backBtnWedding" style={{ cursor: 'pointer' }} onClick={handleBack}>Back</a>
                                                                    <button type="submit" class="addBtnCustomer" style={isSubmitting ? { pointerEvents: "none" } : {}}> {isSubmitting ? (
                                                                        <>
                                                                            <span class="spinner"></span> Continue
                                                                        </>
                                                                    ) : (
                                                                        "Continue"
                                                                    )}</button>
                                                                </div>

                                                            </div>
                                                        </form>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </Container>
        </>
    )
}

export default Comment
